<template>
  <div class="learning">
    <div class="learning_title">
      <slot name="title"></slot>
    </div>
    <div class="learning_content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.learning {
  background: #fff;
  border: 1px solid #c7ced1;
  height: calc(100% - 16px);
  margin-bottom: 14px;
  overflow: hidden;
  .learning_title {
    position: relative;
    padding: 14px;
    font-size: 16px;
    color: #3e4143;
    font-weight: bold;
    border-bottom: 1px solid rgba(155, 155, 155, 0.3);
  }
  .learning_content {
    overflow-y: auto;
    // height: 100%;
    height: calc(100% - 53px);
    // height: calc(92% - 60px);
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
  }
}
</style>
